{
  "version": 1,
  "asset_id": "2949af43-3a83-4cbb-a1eb-e008696e2bf0",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2949af43-3a83-4cbb-a1eb-e008696e2bf0/hiatal-type-3-sleeve-en-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2949af43-3a83-4cbb-a1eb-e008696e2bf0/hiatal-type-3-sleeve-en-800.jpg",
  "original_filename": "hiatal-type-3-sleeve-en-800.jpg",
  "size": 127481,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T23:10:56Z"
}
